import { Divider } from '@sortlist-frontend/design-system/legacy';
import { useTranslation } from '@sortlist-frontend/translation/ssr';
import { useRouter } from 'next/router';
import { FC, useEffect, useState } from 'react';

import {
  OPEN_BRIEFING,
  useBriefingMessage,
  useOpenBriefing,
} from '_components/Briefing/versions/NormalBriefing/BriefingDialog';
import FoundersNotes from '_components/common/FoundersNotes/FoundersNotes';

import { projectConfig } from '../config';
import { Intro } from './components/Intro/Intro';
import Section, { SectionType } from './components/Section/Section';
import { TESTIMONIAL_CARD_WIDTH } from './components/TestimonialCard/TestimonialCard';
import { getMainSections, getTestimonials, getTestimonialsSection } from './project-new.data';

export const NewProjectPage: FC = () => {
  const { t } = useTranslation(projectConfig.i18nNamespaces);
  const [testimonialsSections, setTestimonialsSections] = useState<SectionType>();

  const testimonials = getTestimonials(t);
  const { sendMessage } = useBriefingMessage();
  const { openBriefing } = useOpenBriefing();
  const {
    query: { autoload },
  } = useRouter();

  const cloneElements = () => {
    const elementsToClone = Math.ceil(window.innerWidth / TESTIMONIAL_CARD_WIDTH);
    const firstElements = testimonials.slice(0, elementsToClone);
    const lastElements = testimonials.slice(-elementsToClone);
    const clonedTestimonials = [...lastElements, ...testimonials, ...firstElements];
    const retrievedSections = getTestimonialsSection(t, clonedTestimonials, elementsToClone);

    setTestimonialsSections(retrievedSections);
  };

  useEffect(() => {
    cloneElements();
  }, []);

  useEffect(() => {
    if (autoload == null) return;
    openBriefing({ cta: 'project-new-autoload' }, { replace: true });
  }, [autoload]);

  useEffect(() => {
    window.addEventListener('resize', cloneElements);

    return () => {
      window.removeEventListener('resize', cloneElements);
    };
  }, []);

  const handleStartBriefing = () => {
    sendMessage(OPEN_BRIEFING, { cta: 'project-new-post' });
  };

  const mainSections = getMainSections(t, handleStartBriefing);
  const postProjectSection = mainSections.find((section) => section.name === 'post-project') as SectionType;

  const sections =
    testimonialsSections != null
      ? [...mainSections.slice(0, -1), testimonialsSections, postProjectSection]
      : mainSections;

  return (
    <div id="project-new" className="bg-secondary-50">
      <Intro />
      {sections.map((section, index) => (
        <Section showBackground={index % 2 === 0} key={`${section.name}`} {...section} />
      ))}
      <FoundersNotes />
      <Divider />
    </div>
  );
};
